import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import MainCard from 'components/MainCard';

export default function CenteredStatusCard({ children, maxWidth = 480, sx }) {
  return (
    <Box
      sx={{
        minHeight: { xs: 'calc(100dvh - 96px)', md: 'auto' },
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        px: { xs: 0, sm: 2 },
        py: { xs: 0, sm: 2 },
        ...(sx || {})
      }}
    >
      <Box sx={{ maxWidth, width: '100%' }}>
        <MainCard
          sx={{
            borderRadius: { xs: 0, sm: 1 },
            border: { xs: 'none', sm: undefined },
            boxShadow: { xs: 'none', sm: undefined }
          }}
        >
          {children}
        </MainCard>
      </Box>
    </Box>
  );
}

CenteredStatusCard.propTypes = {
  children: PropTypes.node,
  maxWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  sx: PropTypes.object
};
